import React from "react";

import { Drawer } from "../../../components/Drawer";
import { Input } from "../../../components/Input";
import { Button } from "../../../components/Button";
import { Hairline } from "../../../components/Hairline";
import { Label } from "../../../components/Label";
import { Icon } from "../../../components/core/Icon";

import styles from "../../../../styles/blocked-customers.module.scss";
import { UserSquare } from "../../../components/Icons";
import { EnvironmentsAPI } from "../../../../providers/EnvironmentsAPI";
import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";
import { CPF } from "../../../tools/CPF";

export default class BlockedCustomers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      customer: "",
      loading: false,
    };
  }

  async componentDidMount() {
    const holdingId = await EnvironmentStorage.getEnvironmentHoldingId();
    const customers = await EnvironmentsAPI.getConfigurationsByAlias(
      holdingId,
      "blocked_customers",
      []
    );

    this.setState({
      customers,
    });
  }

  addNewCustomer() {
    const { customers, customer } = this.state;

    if (!customers.includes(customer)) {
      this.setState({ customers: [customer, ...customers] });
    }

    this.setState({ customer: "" });
  }

  removeCustomer(value) {
    const { customers } = this.state;

    const index = customers.indexOf(value);
    const copy = [...customers];

    if (index > -1) copy.splice(index, 1);

    this.setState({ customers: copy });
  }

  formatPhone(phone) {
    let phoneNumber = phone.replace(/\D/g, "");
    phoneNumber = phoneNumber.replace(/^0/, "");

    if (phoneNumber.length > 10) {
      phoneNumber = phoneNumber.replace(
        /^(\d\d)(\d{5})(\d{4}).*/,
        "($1) $2-$3"
      );
    } else if (phoneNumber.length > 7 && phoneNumber.length <= 10) {
      phoneNumber = phoneNumber.replace(
        /^(\d\d)(\d{4})(\d{0,4}).*/,
        "($1) $2-$3"
      );
    } else if (phoneNumber.length > 2 && phoneNumber.length <= 7) {
      phoneNumber = phoneNumber.replace(/^(\d\d)(\d{0,5})/, "($1) $2");
    } else if (phone.trim() !== "") {
      phoneNumber = phoneNumber.replace(/^(\d*)/, "($1");
    }

    return phoneNumber;
  }

  checkIfIsValid() {
    const { customer } = this.state;

    if (!customer) {
      return false;
    }

    const phone = (customer || "").replace(/[^0-9]+/g, "");
    const isPhone = phone && phone.length === 11;
    const isEmail = customer.match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/);
    return isPhone || isEmail;
  }

  format(value) {
    const normalizedValue = value = (value || '').toLowerCase().trim();

    const probablePhone = normalizedValue.replace(/[^0-9]+/g, "").match(/^([0-9]{2}9)/g);
    const probableEmail = normalizedValue.match(/^([a-z-.][\w]+)|^([\w-.]+@)/);
    const isDoc = CPF.validate(normalizedValue);

    if (isDoc) {
      return CPF.mask(normalizedValue);
    }

    if (!probableEmail && probablePhone) {
      return this.formatPhone(normalizedValue);
    }

    return normalizedValue;
  }

  async save() {
    const { customers } = this.state;

    this.setState({ loading: true });
    const holdingId = await EnvironmentStorage.getEnvironmentHoldingId();

    const blockResponse = await EnvironmentsAPI.putConfigurationsByAlias(
      holdingId,
      "blocked_customers",
      {
        blocked_customers: customers,
      }
    );

    if (blockResponse.getErrors([]).length > 0) {
      alert({
        text: blockResponse.getErrors()[0],
        buttonText: "Ok",
      });
      this.setState({ loading: false });
      return false;
    }

    alert({
      text: "Configurações alteradas sucesso",
      buttonText: "Ok",
    });

    this.setState({ loading: false });
    return true;
  }

  render() {
    const { visible, onClose } = this.props;
    const { customers, customer, loading } = this.state;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title="Clientes bloqueados"
      >
        <Input
          label="Bloqueie um e-mail, número de telefone ou CPF"
          placeholder="---"
          design="two"
          value={customer}
          onChange={(e) =>
            this.setState({ customer: this.format(e.target.value) })
          }
        />
        <Button
          className="mt-15"
          onClick={() => this.addNewCustomer()}
          disabled={!this.checkIfIsValid()}
        >
          Adicionar
        </Button>

        <Hairline className="mt-20 mb-20" />

        <Label>Bloqueados ({customers.length})</Label>

        {customers.length === 0 ? (
          <div className={styles.empty}>
            <Icon name="fa-ban" light size="2x" />
            <p>Nenhum contato bloqueado.</p>
          </div>
        ) : (
          <div className={styles.blocked}>
            {customers.map((customer) => (
              <div className={styles.customer} key={customer}>
                <div className="d-flex align-center">
                  <UserSquare />
                  <p className={styles.phoneOrEmail}>{customer}</p>
                </div>
                <div
                  className={styles.remove}
                  onClick={() => this.removeCustomer(customer)}
                >
                  <Icon name="fa-times" />
                </div>
              </div>
            ))}
          </div>
        )}

        <div className={styles.footer}>
          <Button
            className="w-100"
            design="primary"
            disabled={loading}
            loading={loading}
            onClick={() => this.save()}
          >
            Salvar
          </Button>
        </div>
      </Drawer>
    );
  }
}
